import { ElementRef, Injectable } from "@angular/core";
import { filter, fromEvent, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class EventService {
  fromClick(elementRef: ElementRef, className: string): Observable<Event> {
    return fromEvent<Event>(elementRef.nativeElement, "click").pipe(
      filter((event) => (event?.target as HTMLElement)?.classList?.contains(className))
    );
  }
}
